import axios from './axiosInstance';
import { jsonToFormData } from "./converters";

export const practiceTemplatesList = async (params = {}) => {
  const response = await axios.get("/club_api/practice_templates", { params });
  return response.data;
};

export const practiceTemplatesDetails = async (id) => {
  const response = await axios.get("/club_api/practice_templates/" + id);
  return response.data;
};

export const savePracticeTemplates = async (practice_template) => {
  const headers = { 'Content-Type': 'multipart/form-data' }
  const formData = jsonToFormData(practice_template, "practice_template")
  const response = !practice_template?.id
    ? await axios.post("/club_api/practice_templates/", formData, { headers } )
    : await axios.put("/club_api/practice_templates/" + practice_template.id, formData, { headers } );
  return response.data;
};


export const practiceCategories = async () => {
  const response = await axios.get("/club_api/practice_templates/categories");
  return response.data;
};

export const removePracticeTemplates = async (id) => {
  const response = await axios.delete(`/club_api/practice_templates/${id}`);
  return response.data;
};

export const copyTemplate = async (id) => {
  const response = await axios.get(`/club_api/practice_templates/${id}/copy`);
  return response.data;
};
